import { memo, useCallback } from "react";
import { IAvaiableSchedule, ISchedule } from "../../../model";
import { Grid, Stack, Typography } from "@mui/material";
import Hour from "./Hour";

interface IScheduleItemProps {
  data: IAvaiableSchedule;
  onSelectedHour: (hour?: ISchedule) => void;
  selectedHour?: ISchedule;
}

const ScheduleItem: React.FC<IScheduleItemProps> = ({
  data: {
    schedules,
    descriptionSite,
    calendarShortName,
  },
  onSelectedHour,
  selectedHour,
}) => {
  const handlePress = useCallback(
    (hour: ISchedule) => {
      if (hour.identifier === selectedHour?.identifier) {
        onSelectedHour(undefined);
      } else {
        onSelectedHour(hour);
      }
    },
    [onSelectedHour, selectedHour]
  );

  return (
    <Stack gap={1}>
      <Typography>{calendarShortName}</Typography>
      <Typography>{descriptionSite}</Typography>
      <Grid container direction={"row"} spacing={1}>
        {schedules.map((s) => (
          <Hour
            schedule={s}
            key={s.identifier}
            onPress={handlePress}
            selected={s.identifier === selectedHour?.identifier}
          />
        ))}
      </Grid>
    </Stack>
  );
};

export default memo(ScheduleItem);
